// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"57c69ae8","334":"2bcc56c7","453":"ae00d294"}[chunkId] + ".chunk.js";
};